import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'
import { migrateAgreement } from './migrateAgreement'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.AGREEMENT,
    migrateFunction: migrateAgreement,
  })
}
